import { Suspense, lazy } from 'react';
import { Navigate } from 'react-router-dom';
import SuspenseLoader from 'src/components/SuspenseLoader';

export const Loader = (Component) => (props) =>
(
    <Suspense fallback={<SuspenseLoader />}>
        <Component {...props} />
    </Suspense>
);

const Reception = Loader(lazy(() => import('src/content/reception/client')));
const CheckIn = Loader(lazy(() => import('src/content/reception/checkin')));
const Payment = Loader(lazy(() => import('src/content/reception/payment')));
const Report = Loader(lazy(() => import('src/content/reception/report')));


const receptionRoutes = [
    {
        path: '',
        element: <Navigate to="check-in" replace />
    },
    {
        path: 'register',
        element: <Reception />
    },
    {
        path: 'check-in',
        element: <CheckIn />
    },
    {
        path: 'payment',
        element: <Payment />
    },
    {
        path: 'report',
        element: <Report />
    },

];

export default receptionRoutes;